import { Box, Stack, Typography } from '@mui/material'
import React from 'react'

import { ShareableListType } from 'components/configurations/clusters/clusters-utils'
import { OwnedClusterList } from 'components/configurations/clusters/OwnedClusterList'
import { ShareableClusterList } from 'components/configurations/clusters/ShareableClusterList'

import type {
  AvailableK8sClusterAsset,
  SharedAssetsResponse
} from 'types/api/sharedAssets/sharedAssets'

export const ClustersListContainer: React.FC<{
  sharedAssets: SharedAssetsResponse
}> = ({ sharedAssets }) => {
  const { myClusters, availableClusters } = sharedAssets

  const { sharedClusters, unsharedClusters } = availableClusters.reduce(
    (
      acc: {
        sharedClusters: AvailableK8sClusterAsset[]
        unsharedClusters: AvailableK8sClusterAsset[]
      },
      cluster
    ) => {
      if (cluster.currentlySharedNamespaces.length > 0) {
        acc.sharedClusters.push(cluster)
      } else {
        acc.unsharedClusters.push(cluster)
      }

      return acc
    },
    { sharedClusters: [], unsharedClusters: [] }
  )

  return (
    <Stack data-testid="clusters-list-container" sx={{ rowGap: 4 }}>
      <Stack sx={{ rowGap: 2 }}>
        <Typography sx={{ fontWeight: 'bold' }} variant="body1">
          Owned
        </Typography>
        <OwnedClusterList ownedClusters={myClusters} />
      </Stack>
      <Stack sx={{ rowGap: 2 }}>
        <Typography sx={{ fontWeight: 'bold' }} variant="body1">
          Shared
        </Typography>
        <Box data-testid="shared-cluster-list">
          <ShareableClusterList
            availableClusters={sharedClusters}
            shareableListType={ShareableListType.SHARED}
          />
        </Box>
      </Stack>
      <Stack sx={{ rowGap: 2 }}>
        <Typography sx={{ fontWeight: 'bold' }} variant="body1">
          Not Shared
        </Typography>
        <Box data-testid="not-shared-cluster-list">
          <ShareableClusterList
            availableClusters={unsharedClusters}
            shareableListType={ShareableListType.NOT_SHARED}
          />
        </Box>
      </Stack>
    </Stack>
  )
}
